import React, {useEffect, useState} from "react"
import MetaTags from "react-meta-tags"
import {Container, Card, CardBody, Nav, NavItem, NavLink} from "reactstrap"
import classnames from "classnames"
import {withRouter} from "react-router"
import {withTranslation} from "react-i18next"
import PropTypes from "prop-types"
import DataTableEtudiantImportation from "./DataTableEtudiantImportation"
import DataTableEtudiantScore from "./DataTableEtudiantScore"
const EtudiantImportation = props => {
    const [section, setSection] = useState(1)
    const [add, setAdd] = useState(0);
    const [cloture, setCloture] = useState(0);
    useEffect(async () => {
        var cloture_annee = JSON.parse(localStorage.getItem("cloture"));
        setCloture(cloture_annee)
        const userAuth = JSON.parse(localStorage.getItem('UserMenu'));
        const typeArticleSubMenu = userAuth.find(user =>
          user.sous_menu.some(
            subMenu =>
              subMenu.sous_menu === "Importation listes Etudiants"
          )
        )
        setAdd(typeArticleSubMenu.sous_menu[3].add)
    }, [])
    const back = () => {
        setSection(1)
    }
    const renderBlock = section => {
        if (section === 1) {
          return <DataTableEtudiantImportation />
        }else if(section === 2) {
          return <DataTableEtudiantScore />
        }
    }
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>
              {props.t("Importation listes des étudiants Orientation")} | Cresus{" "}
            </title>
          </MetaTags>
          <Container fluid>
            <div>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: section === 1,
                    })}
                    onClick={() => {
                      setSection(1)
                    }}
                  >
                    {props.t("Importation listes des étudiants Orientation")}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: section === 2,
                    })}
                    onClick={() => {
                      setSection(2)
                    }}
                  >
                    {props.t("Résultats de scores des étudiants")}
                  </NavLink>
                </NavItem>
              </Nav>
              <Card>
                <CardBody>{renderBlock(section)}</CardBody>
              </Card>
            </div>
          </Container>
        </div>
      </React.Fragment>
    )
}

export default withRouter(withTranslation()(EtudiantImportation))
EtudiantImportation.propTypes = {
    t: PropTypes.any,
}
